import { useRef } from 'react';

import { createSchemaField } from '@formily/react';
import {
  FormItem,
  Input,
  Checkbox,
  Radio,
  Switch,
  FormGrid,
  FormButtonGroup,
  Submit,
  Upload,
  DatePicker,
  NumberPicker,
} from '@formily/antd-v5';
import FormTriggerActionButton from '../components/form-trigger-action-button';
import FormArrayTable from '../components/form-array-table';
import FormFlowChart from '../components/flow-chart';
import FormEditor from '../components/form-editor';
import FormFilesUpload from '../components/form-files-upload';
import FormReferenceSelect from '../components/reference-select';
import FormReferenceTreeSelect from '../components/reference-tree-select';
import FormReferenceTreeSelectAsync from '../components/reference-tree-select-async';
import FormFlex from '../components/form-flex';
import FormTitle from '../components/form-title';
import FormText from '../components/form-text';
import FormLink from '../components/form-link';
import FormImportInstance from '../components/form-import-instance';
import FormBox from '../components/form-box';
import FormSelect from '../components/form-select';
import FormTabs from '../components/form-tabs';
import FormRecursionItem from '../components/form-recursion-item';
import { FormChunkUpload } from '../components';

const createSchemaFields = () =>
  createSchemaField<any>({
    components: {
      FormItem,
      Input,
      Checkbox,
      Radio,
      Select: FormSelect,
      DatePicker,
      Switch,
      FormGrid,
      FormButtonGroup,
      Submit,
      FormTriggerActionButton,
      Upload,
      ArrayTable: FormArrayTable,
      FlowChart: FormFlowChart,
      FormEditor,
      FormFilesUpload,
      FormReferenceSelect,
      FormReferenceTreeSelect,
      FormReferenceTreeSelectAsync,
      NumberPicker,
      FormFlex,
      FormTitle,
      FormText,
      FormLink,
      FormImportInstance,
      FormBox,
      FormTabs,
      FormRecursionItem,
      FormChunkUpload,
    },
  });

export default createSchemaFields;
